import { render, staticRenderFns } from "./AppointmentsColumn.vue?vue&type=template&id=a1b3f174&scoped=true"
import script from "./AppointmentsColumn.vue?vue&type=script&lang=ts"
export * from "./AppointmentsColumn.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsColumn.vue?vue&type=style&index=0&id=a1b3f174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b3f174",
  null
  
)

export default component.exports